import { InjectionToken } from '@angular/core';

import { ItemToolbarConfiguration } from '../services';
export const ITEMS_TOOLBAR_CONFIGURATION_TOKEN = new InjectionToken<ItemToolbarConfiguration[]>('ITEMS_TOOLBAR_CONFIGURATION_TOKEN');
